import useAPIClient from "../../core/services/API/hooks/useAPIClient";
import PaymentLink from "../../payment/types/PaymentLink";
import {useCallback} from "react";
import {Tpv} from "../../payment/enum/Tpv";

interface PayWithSavedCardInput {
    transferId: string;
    uuid: string;
    tpv: Tpv;
    paymentCardUuid?: string;
}

export default function useTransferPayWithSavedCard() {
    const client = useAPIClient();

    return useCallback(({uuid, transferId, tpv, paymentCardUuid}: PayWithSavedCardInput): Promise<PaymentLink> => {
        return client.post<PaymentLink>(`transfers/${uuid}/payment_link`, {
            transfer: transferId,
            tpv: tpv,
            paymentCard: paymentCardUuid,
        });
    }, [client]);
}
